export const SET_WORD_CLOUD = 'ROOM/WORDCLOUD/SET_WORD_CLOUD'
export const SET_WORDS_CLOUD = 'ROOM/WORDCLOUD/SET_WORDS_CLOUD'
